import React, { ReactNode, useState } from 'react';
import { FormattedMessage } from 'react-intl';
import { get } from 'lodash';

import { Box, Button, Stack } from '@mui/material';

import { HeatPump, OemDistribution } from '../../../core/src/shared/enums';
import { useSelector } from '../store/utils';

import { ControlBox } from '../atoms/control-box';
import { HeatPumpWizard } from './heat-pump-wizard/heat-pump-wizard';

export const HeatPumpTypeSelect = () => {
  const [wizardOpen, setWizardOpen] = useState(false);
  const wizardHeatPumpInfo = useWizardHeatPumpInfo();

  const wizardBox = (
    <Stack gap={0.75}>
      {wizardHeatPumpInfo}
      <Button
        variant="outlined"
        size="small"
        onClick={() => setWizardOpen(true)}
      >
        <FormattedMessage
          id="heat_pump_wizard.open"
          defaultMessage="Nastavit typ TČ"
        />
      </Button>
    </Stack>
  );

  return (
    <>
      <ControlBox
        control={wizardBox}
        title={
          <FormattedMessage
            id="settings.heatpump.hp_type"
            defaultMessage="Typ tepelného čerpadla"
          />
        }
        visibility={{ variableId: 'HP_ENABLED' }}
        fullWidth
      />

      <HeatPumpWizard open={wizardOpen} onClose={() => setWizardOpen(false)} />
    </>
  );
};

const useWizardHeatPumpInfo = () => {
  const heatPumpType = useSelector((s) => s.variables.HP_TYPE);
  const includeNibe = useSelector(
    (s) => get(s.variables, 'OEM_DISTRIBUTION') === OemDistribution.DZD
  );

  const mapped = heatPumpMapping(includeNibe)[heatPumpType as HeatPump];
  return <Box>{mapped || null}</Box>;
};

const heatPumpMapping = (
  includeNibe: boolean
): Partial<Record<HeatPump, ReactNode>> => ({
  [HeatPump.Ecoone]: (
    <FormattedMessage id="heat_pump.ecoone" defaultMessage="Ecoone" />
  ),
  ...(includeNibe
    ? {
        [HeatPump.Nibe]: (
          <FormattedMessage id="heat_pump.nibe" defaultMessage="Nibe" />
        ),
      }
    : {}),
  [HeatPump.Acond]: (
    <FormattedMessage id="heat_pump.acond" defaultMessage="Acond" />
  ),
});
